module.exports = __webpack_public_path__ + "img/served_cold.e47d7a90.png";